import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ReportsComponent } from './reports.component';
import { AuthGuard } from 'shared/auth/auth.guard';
import { SubscriptionGuard } from 'shared/subscription/subscription.guard';
import { PermissionsResolver } from 'shared/permissions/permissions.resolver';
import { PermissionsGuard } from 'shared/permissions/permissions.guard';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'reports/:page',
        component: ReportsComponent,
        canActivate: [AuthGuard, SubscriptionGuard, PermissionsGuard],
        data: { permissions: ['admin'] },
        resolve: { permissions: PermissionsResolver }
      },
      {
        path: 'reports',
        redirectTo: 'reports/download',
        pathMatch: 'full',
      },
    ])
  ],
  exports: [RouterModule],
})
export class ReportsRoutingModule { }
